import * as XLSX from "xlsx";

type ExportRow = Record<string, unknown>;

interface ExportToExcelParams {
  rows: ExportRow[];
  sheetName: string;
  fileName: string; // should end with .xlsx; if not, we append
}

// Best-effort auto width based on cell content lengths
function autoSizeColumns(rows: ExportRow[]) {
  if (!rows || rows.length === 0) return [] as XLSX.ColInfo[];
  const headers = Object.keys(rows[0] ?? {});
  const colWidths = headers.map((h) => Math.max(10, String(h).length));

  for (const row of rows) {
    headers.forEach((h, idx) => {
      const cellValue = row[h];
      const str = cellValue == null ? "" : String(cellValue);
      colWidths[idx] = Math.max(colWidths[idx], str.length + 2);
    });
  }

  return colWidths.map((wch) => ({ wch }));
}

export function exportToExcel({ rows, sheetName, fileName }: ExportToExcelParams) {
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;
  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet["!cols"] = autoSizeColumns(rows);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, safeFileName);
}

interface ExportSheet {
  sheetName: string;
  rows: ExportRow[];
}

interface ExportToExcelMultiSheetParams {
  fileName: string;
  sheets: ExportSheet[];
}

export function exportToExcelMultiSheet({ fileName, sheets }: ExportToExcelMultiSheetParams) {
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;
  const workbook = XLSX.utils.book_new();
  for (const sheet of sheets) {
    const worksheet = XLSX.utils.json_to_sheet(sheet.rows);
    worksheet["!cols"] = autoSizeColumns(sheet.rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet.sheetName);
  }
  XLSX.writeFile(workbook, safeFileName);
}

